/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { alias } from '@ember/object/computed';
import convertOperator from 'cio/utils/operators/convert';
import { allOperators as operators } from 'cio/utils/conditions-operators';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import { isBlank } from '@ember/utils';
import { serializeFilter as serializeAttributeFilter } from 'cio/utils/conditions/serialize/attribute';
import serializeCollectionFilter from 'cio/utils/conditions/serialize/collection';
import { JsonAttributeOperator } from 'cio/utils/conditions/json-attributes';

function isJsonAttributeOperator(operator) {
  return Object.values(JsonAttributeOperator).includes(operator);
}

export default class Attribute extends BaseEditorComponent {
  @service environment;

  // external API
  variation = null;
  subLayout = null;
  campaign = null;
  allowComparisonOperator = false;
  allowArrayOperators = false;
  allowedConditionOperators = null;
  allowJsonOperators = false;
  disabled = false;

  condition = null;
  allowBlankName = true;
  autosuggestValueOverrides = {};
  isLoadingAutosuggestValueOverrides = false;
  showEventNameInEditor = true;
  onApply() {}

  // internal API
  @alias('environment.sentAttributes') sentAttributes;

  @computed('sentAttributes.[]')
  get attributes() {
    return this.condition.type === 'collection_attribute'
      ? this.condition.collectionSchema.map((value) => ({ value, label: value }))
      : this.sentAttributes.map((attribute, index) => ({ value: index, label: attribute }));
  }

  @computed('condition.{name,value,operator,errors.operator}', 'allowBlankName')
  get errors() {
    let errors = [];

    if (!this.allowBlankName && !this.condition.name) {
      errors.push("Attribute can't be blank.");
    }

    if (isJsonAttributeOperator(this.condition.operator)) {
      return errors;
    }

    let conditionOperator = convertOperator(this.condition.operator, { to: 'attribute' });
    let operator = operators.findBy('value', conditionOperator);
    if (isBlank(this.condition.value) && operator.allowBlankPredicate === false) {
      errors.push("Value can't be blank.");
    }

    if (this.condition.errors.operator?.length) {
      errors.push(this.condition.errors.operator[0]);
    }

    return errors;
  }

  @action
  _onApply() {
    let serializeFilter =
      this.condition.type === 'collection_attribute' ? serializeCollectionFilter : serializeAttributeFilter;
    let condition = serializeFilter(this.condition, false, true, this.allowComparisonOperator);
    condition.operator = convertOperator(condition.operator);
    return this.onApply(condition);
  }
}
